import { useState } from "react";
import { Mail, MapPin, MessageCircle, Send } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  function submit(e) {
    e.preventDefault();
    // Wire this to your backend or email service (e.g. Formspree, Resend)
    setSent(true);
    setTimeout(() => setSent(false), 3000);
  }

  return (
    <section className="section" style={{ paddingTop: 80 }}>
      <div className="container">
        <div className="contact-grid" style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 60,
          alignItems: "start"
        }}>
          <div>
            <h1 style={{ fontSize: "clamp(28px, 3.5vw, 38px)", marginBottom: 14 }}>
              Get in touch
            </h1>
            <p style={{ fontSize: 17, color: "var(--slate)", lineHeight: 1.6, marginBottom: 32 }}>
              Have questions about TokenGuard? Want to report a bug or request a feature? 
              We read every message.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <ContactItem
                icon={<Mail size={20} />}
                title="Email us"
                desc="hello@mytokenguard.com"
                href="mailto:hello@mytokenguard.com"
              />
              <ContactItem
                icon={<MessageCircle size={20} />}
                title="Community"
                desc="GitHub Discussions"
                href="https://github.com/mytokenguard/discussions"
              />
              <ContactItem
                icon={<MapPin size={20} />}
                title="Office"
                desc="Remote-first, Earth"
              />
            </div>
          </div>

          <div style={{
            background: "var(--card-surface)",
            border: "1px solid var(--stone)",
            borderRadius: "var(--radius-lg)",
            padding: 32
          }}>
            {sent ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <div style={{
                  width: 48, height: 48, borderRadius: "50%",
                  background: "rgba(46,125,107,0.12)", color: "var(--accent)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto 16px"
                }}>
                  <Send size={22} />
                </div>
                <h3 style={{ fontSize: 18, marginBottom: 6 }}>Message sent</h3>
                <p style={{ fontSize: 14, color: "var(--slate)" }}>We'll get back to you shortly.</p>
              </div>
            ) : (
              <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <Field label="Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required />
                <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} required />
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  <label style={{ fontSize: 12.5, fontWeight: 600, color: "var(--slate)" }}>Message</label>
                  <textarea
                    required
                    rows={5}
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "12px 14px",
                      borderRadius: "var(--radius-sm)",
                      border: "1.5px solid var(--stone)",
                      background: "var(--elevated-surface)",
                      fontFamily: "var(--font-body)",
                      fontSize: 14,
                      resize: "vertical"
                    }}
                  />
                </div>
                <button type="submit" className="btn btn-primary" style={{ width: "100%" }}>
                  Send message <Send size={16} />
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

function Field({ label, type = "text", value, onChange, required }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <label style={{ fontSize: 12.5, fontWeight: 600, color: "var(--slate)" }}>{label}</label>
      <input
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          height: 44,
          padding: "0 14px",
          borderRadius: "var(--radius-sm)",
          border: "1.5px solid var(--stone)",
          background: "var(--elevated-surface)",
          fontFamily: "var(--font-body)",
          fontSize: 14
        }}
      />
    </div>
  );
}

function ContactItem({ icon, title, desc, href }) {
  const content = (
    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
      <div style={{ color: "var(--accent)" }}>{icon}</div>
      <div>
        <p style={{ fontSize: 13.5, fontWeight: 600 }}>{title}</p>
        <p style={{ fontSize: 13.5, color: "var(--slate)" }}>{desc}</p>
      </div>
    </div>
  );
  return href ? (
    <a href={href} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
      {content}
    </a>
  ) : content;
}
